import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginTenantLinksContainerModel } from "../../../../../models";
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination } from "../shared";

@Injectable({
    providedIn: 'root',
})
export class LoginTenantLinksTenantLevelService extends BaseApiTemplateService<LoginTenantLinksContainerModel> {
    constructor(http: HttpClient){
        super();
        this.httpClient = http;
    }

    private setUrl(endpoint: string){
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + `login-subject-tenant-link/${endpoint}` ;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + `login-subject-tenant-link/${endpoint}`;
    }

    backofficePost(dtoObject: LoginTenantLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl('backoffice-ep');
        return super.post(dtoObject, apiVisa)
    }

    backofficeDelete(guid: string, apiVisa: ApiVisa){
        this.setUrl('backoffice-ep');
        return super.delete(guid, apiVisa);
    }

    backofficePut(dtoObject: LoginTenantLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl('backoffice-ep');
        return super.put(dtoObject, apiVisa);
    }

    backofficeGetAll(apiVisa: ApiVisa){
        this.setUrl('backoffice-ep');
        return super.get(apiVisa);
    }

    backofficeGetByGuid(guid: string, apiVisa: ApiVisa){
        this.setUrl('backoffice-ep');
        return super.getByGuid(guid, apiVisa);
    }

    backofficeGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
        this.setUrl('backoffice-ep');
        return super.getByCriteria(pagination, apiVisa);
    }


    tenantEpPost(dtoObject: LoginTenantLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl('tenant-ep');
        return super.post(dtoObject, apiVisa)
    }

    tenantEpDelete(guid: string, apiVisa: ApiVisa){
        this.setUrl('tenant-ep');
        return super.delete(guid, apiVisa);
    }

    tenantEpPut(dtoObject: LoginTenantLinksContainerModel, apiVisa: ApiVisa){
        this.setUrl('tenant-ep');
        return super.put(dtoObject, apiVisa);
    }

    tenantEpGetAll(apiVisa: ApiVisa){
        this.setUrl('tenant-ep');
        return super.get(apiVisa);
    }

    tenantEpGetByGuid(guid: string, apiVisa: ApiVisa){
        this.setUrl('tenant-ep');
        return super.getByGuid(guid, apiVisa);
    }

    tenantEpGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
        this.setUrl('tenant-ep');
        return super.getByCriteria(pagination, apiVisa);
    }

    tenantAdminEpGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
        this.setUrl('admins/tenant-ep');
        return super.getByCriteria(pagination, apiVisa);
    }
}